// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isLastDayOfMonth as fn } from "../isLastDayOfMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isLastDayOfMonth = convertToFP(fn, 1);

// Fallback for modularized imports:
export default isLastDayOfMonth;
